import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './updateMenuItemPopMutation.gql';
import { MenuItemFragmentDoc } from '../../fragments/menus/MenuItemFragment.generated';
import { SessionFragmentDoc } from '../../fragments/users/SessionFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_section_MenuSection_menu_Menu_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  allowReservations?: boolean | null,
  city: string,
  customDishTabContent?: string | null,
  customDishTabName?: string | null,
  displayPhone?: string | null,
  isOrderingSpecialInstructionsEnabled?: boolean | null,
  isNcrSilverPayment: boolean,
  email?: string | null,
  name: string,
  openTableId?: string | null,
  phone?: string | null,
  postalCode?: string | null,
  resyApiKey?: string | null,
  resyLinkUrl?: string | null,
  resyVenueId?: number | null,
  slug: string,
  state?: string | null,
  streetAddress: string,
  yelpFriendlyId?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_section_MenuSection_menu_Menu = {
  __typename: 'Menu',
  id: number,
  allowReservation?: boolean | null,
  cateringLeadTimeMinutes: number,
  isCateringMenu: boolean,
  locationId?: number | null,
  menuOrderingUrl?: string | null,
  menuPageUrl?: string | null,
  name: string,
  slug: string,
  url?: string | null,
  location?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_section_MenuSection_menu_Menu_location_RestaurantLocation | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_section_MenuSection = {
  __typename: 'MenuSection',
  id: number,
  name: string,
  menu?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_section_MenuSection_menu_Menu | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_subsection_MenuSubsection = {
  __typename: 'MenuSubsection',
  id: number
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_extraGroups_MenuItemExtraGroup_extras_MenuItemExtraGroupExtra = {
  __typename: 'MenuItemExtraGroupExtra',
  id: number,
  name: string,
  outOfStock?: boolean | null,
  outOfStockUntil?: string | null,
  position?: number | null,
  price?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_extraGroups_MenuItemExtraGroup = {
  __typename: 'MenuItemExtraGroup',
  id: number,
  maxSelectionsCount?: number | null,
  minSelectionsCount?: number | null,
  multiSameSelection?: boolean | null,
  name: string,
  position?: number | null,
  extras: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_extraGroups_MenuItemExtraGroup_extras_MenuItemExtraGroupExtra>
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup_extras_SharedExtraGroupExtra = {
  __typename: 'SharedExtraGroupExtra',
  id: number,
  isDefault: boolean,
  name: string,
  outOfStock?: boolean | null,
  outOfStockUntil?: string | null,
  position?: number | null,
  price?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup = {
  __typename: 'SharedExtraGroup',
  id: number,
  maxSelectionsCount?: number | null,
  minSelectionsCount?: number | null,
  multiSameSelection?: boolean | null,
  name: string,
  extras: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup_extras_SharedExtraGroupExtra>
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup = {
  __typename: 'MenuItemSharedExtraGroup',
  id: number,
  position?: number | null,
  maxSelectionsCount?: number | null,
  minSelectionsCount?: number | null,
  isEnabled?: boolean | null,
  sharedExtraGroup?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_photos_MenuItemPhoto = {
  __typename: 'MenuItemPhoto',
  id: number,
  photoHeight: number,
  photoWidth: number,
  photoUrl?: string | null,
  shareUrl?: string | null,
  thumbnailUrl?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_photos_Photo = {
  __typename: 'Photo',
  id: number,
  photoHeight: number,
  photoWidth: number,
  photoUrl?: string | null,
  shareUrl?: string | null,
  thumbnailUrl?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_photos = UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_photos_MenuItemPhoto | UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_photos_Photo;

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_menu_Menu = {
  __typename: 'Menu',
  id: number,
  cateringLeadTimeMinutes: number,
  locationId?: number | null,
  isCateringMenu: boolean,
  menuType: string
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_dish_Dish_allSelectedDishTags_DishTagObject = {
  __typename: 'DishTagObject',
  id: string,
  abbr: string,
  color: string,
  imageIconUrl?: string | null,
  name: string
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_dish_Dish = {
  __typename: 'Dish',
  id: number,
  featured?: boolean | null,
  isCreatedByMenuSync?: boolean | null,
  updateInProgress?: boolean | null,
  allSelectedDishTags: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_dish_Dish_allSelectedDishTags_DishTagObject>
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sizes_MenuItemSize = {
  __typename: 'MenuItemSize',
  id: number,
  name: string,
  price?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_extras_MenuItemExtra = {
  __typename: 'MenuItemExtra',
  id: number,
  name: string,
  outOfStock?: boolean | null,
  outOfStockUntil?: string | null,
  price?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_featuredPhoto_MenuItemPhoto = {
  __typename: 'MenuItemPhoto',
  id: number,
  photoUrl?: string | null,
  thumbnailUrl?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null,
  thumbnailUrl?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_featuredPhoto = UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_featuredPhoto_MenuItemPhoto | UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_featuredPhoto_Photo;

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  allowAnonymousPops?: boolean | null,
  allowAnonymousReviews?: boolean | null,
  customDishTabContent?: string | null,
  customDishTabName?: string | null,
  followButtonCta: string,
  followHeadingCta: string,
  followSubheadingCta: string,
  name: string
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  cateringOrderMax?: number | null,
  cateringOrderMin?: number | null,
  containsAlcohol: boolean,
  currency: string,
  customTaxRateId?: number | null,
  description?: string | null,
  dishId?: number | null,
  featured?: boolean | null,
  likedItPopsCount: number,
  lovedItPopsCount: number,
  htmlContent?: string | null,
  isDoordashDelivery?: boolean | null,
  isEnabled?: boolean | null,
  isOrderingEnabled?: boolean | null,
  isPoppable?: boolean | null,
  isTaxable?: boolean | null,
  masterItemId?: number | null,
  name: string,
  outOfStock?: boolean | null,
  outOfStockUntil?: string | null,
  photosCount?: number | null,
  popsCount: number,
  price?: number | null,
  priceCustomText?: string | null,
  priceType?: string | null,
  restaurantId?: number | null,
  reviewsCount: number,
  shortLinkUrl?: string | null,
  showDisclaimer?: boolean | null,
  showFeaturedPhoto?: boolean | null,
  slug: string,
  wannaTryPopsCount: number,
  url?: string | null,
  visitsCount?: number | null,
  section?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_section_MenuSection | null,
  subsection?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_subsection_MenuSubsection | null,
  extraGroups: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_extraGroups_MenuItemExtraGroup>,
  sharedExtraGroups: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup>,
  photos: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_photos>,
  menu: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_menu_Menu,
  dish?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_dish_Dish | null,
  sizes: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_sizes_MenuItemSize>,
  extras: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_extras_MenuItemExtra>,
  featuredPhoto?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_featuredPhoto | null,
  restaurant: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem_restaurant_Restaurant
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  calendarEventId?: number | null,
  id: number,
  popType?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  id: number,
  calendarEventId?: number | null,
  popType?: string | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_reviews_Review_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null,
  restaurant?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_reviews_Review_restaurant_Restaurant | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  slug: string
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_followers_Follower = {
  __typename: 'Follower',
  id: number,
  isSmsUnsubscribed?: boolean | null,
  isUnsubscribed?: boolean | null,
  restaurantId: number,
  favoriteLocation?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User = {
  __typename: 'User',
  id: number,
  adminPaletteType?: string | null,
  currentSignInAt?: string | null,
  orderAudioType?: string | null,
  authyStatus?: string | null,
  avatarUrl?: string | null,
  birthDay?: number | null,
  birthMonth?: number | null,
  createdAt?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null,
  fullName?: string | null,
  isPendingPassword?: boolean | null,
  isRoot: boolean,
  isRootStaging: boolean,
  isSmsUnsubscribed?: boolean | null,
  isTextValidated: boolean,
  isUnsubscribed?: boolean | null,
  lastFourDigitsPhoneNumber?: string | null,
  lastName?: string | null,
  phone?: string | null,
  isMobilePhone?: boolean | null,
  thumbnailUrl?: string | null,
  userRole?: string | null,
  calendarEventPops?: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_calendarEventPops_CalendarEventPop> | null,
  pops: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_pops_Pop>,
  reviews: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_reviews_Review>,
  reviewUpvotes: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_reviewUpvotes_ReviewUpvote>,
  followers: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User_followers_Follower>
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session = {
  __typename: 'Session',
  id: string,
  avatarUrl?: string | null,
  isAuthyRequired: boolean,
  isAuthyVerified: boolean,
  isSoftAuthenticated: boolean,
  calendarEventPops: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_calendarEventPops_CalendarEventPop>,
  pops: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_pops_Pop>,
  reviews: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_reviews_Review>,
  reviewUpvotes: Array<UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_reviewUpvotes_ReviewUpvote>,
  user?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session_user_User | null
};

export type UpdateMenuItemPopMutation_updateMenuItemPop_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string,
  item?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_item_MenuItem | null,
  session?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop_session_Session | null
};

export type UpdateMenuItemPopMutation_Mutation = {
  __typename?: 'Mutation',
  updateMenuItemPop?: UpdateMenuItemPopMutation_updateMenuItemPop_Pop | null
};


export type UpdateMenuItemPopMutationVariables = Types.Exact<{
  menuItemId: Types.Scalars['Int']['input'];
  popType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  menuItemCartReviewToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateMenuItemPopMutation = UpdateMenuItemPopMutation_Mutation;


export const UpdateMenuItemPopDocument = /*#__PURE__*/ document as unknown as DocumentNode<UpdateMenuItemPopMutation, UpdateMenuItemPopMutationVariables>;

export type UpdateMenuItemPopMutationFn = ApolloReactCommon.MutationFunction<UpdateMenuItemPopMutation, UpdateMenuItemPopMutationVariables>;

/**
 * __useUpdateMenuItemPopMutation__
 *
 * To run a mutation, you first call `useUpdateMenuItemPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuItemPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param options options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuItemPopMutation, { data, loading, error }] = useUpdateMenuItemPopMutation({
 *   variables: {
 *      menuItemId: // value for 'menuItemId'
 *      popType: // value for 'popType'
 *      menuItemCartReviewToken: // value for 'menuItemCartReviewToken'
 *   },
 * });
 */
export function useUpdateMenuItemPopMutation(options?: ApolloReactHooks.MutationHookOptions<UpdateMenuItemPopMutation, UpdateMenuItemPopMutationVariables>) {
                return ApolloReactHooks.useMutation<UpdateMenuItemPopMutation, UpdateMenuItemPopMutationVariables>(UpdateMenuItemPopDocument, options);
      }
export type UpdateMenuItemPopMutationHookResult = ReturnType<typeof useUpdateMenuItemPopMutation>;
export type UpdateMenuItemPopMutationResult = ApolloReactCommon.MutationResult<UpdateMenuItemPopMutation>;
export type UpdateMenuItemPopMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMenuItemPopMutation, UpdateMenuItemPopMutationVariables>;